// 📁 Imports
import validator from "validator";
import { isValidPhoneNumber, parsePhoneNumber } from "libphonenumber-js";

import {
  showErrorMessage,
  showSuccessMessage,
  clearErrorMessage,
} from "@/utils/input-message.js";

// import { showResponseMessage } from "./response-message.js";

// import { buttonLoaderShow, buttonLoaderHide } from "../components/button.js";

// 💾 Variables
// const formValidate = document.querySelector(".js-form-validate");
const validateInputs = document.querySelectorAll("[data-validate]");
// let errors = [];

// 📐 Functions

// Rules
// ❗ Validate is not empty
const isRequired = (value, input) => {
  let isInvalid = validator.isEmpty(value || "", {
    ignore_whitespace: true,
  });
  const isValid = !isInvalid;

  if (value === "[]") {
    isInvalid = true;
  }

  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(input, "[data-validate-required-message]");
  } else {
    showSuccessMessage(input);
  }

  return isValid;
};

// ❗ Validate phone
const isPhoneWithCountryCode = (value, input) => {
  const inputWrapper = input.closest("[data-input-phone-country-wrapper]");
  const inputHidden = inputWrapper.querySelector("[data-input-phone-value]");
  let isValid;

  if (input.dataset.inputValidatePhoneCountry !== "INTERNATIONAL") {
    try {
      inputHidden.value = parsePhoneNumber(
        value,
        input.dataset.inputValidatePhoneCountry,
      ).number;

      isValid = parsePhoneNumber(
        value,
        input.dataset.inputValidatePhoneCountry,
      ).isPossible();
    } catch (err) {
      inputHidden.value = "";
      isValid = false;
      console.log(err);
    }
  } else {
    try {
      isValid = parsePhoneNumber(value, null).isPossible();
      inputHidden.value = parsePhoneNumber(value, null).number;
    } catch (err) {
      inputHidden.value = "";
      isValid = false;
      console.log(err);
    }
  }

  let isInvalid = value.length === 0 ? false : !isValid;
  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(inputHidden, "[data-validate-phone-format-message]");
  } else {
    showSuccessMessage(input);
  }
  return isValid;
};

// ❗ Validate phone
const isPhone = (value, input) => {
  const isValid = isValidPhoneNumber(value);
  const isInvalid = !isValid;

  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(input, "[data-validate-phone-message]");
  } else {
    showSuccessMessage(input);
  }
  return isValid;
};

// ❗ Validate radio is checked
const isCheckedGroup = (input) => {
  const radio = document.querySelector(`input[name="${input.name}"]:checked`);
  const radioRequired = document.querySelector(
    `input[name="${input.name}"][data-validate-radio-checked][data-validate-radio-checked]`,
  );
  const isValid = radio !== null && radioRequired !== null ? true : false;
  const isInvalid = !isValid;

  if (isInvalid) {
    radioRequired.setCustomValidity(" ");
    showErrorMessage(radioRequired, "[data-validate-radio-checked-message]");
  }
  return isValid;
};

// ❗ Validate is checked
const isChecked = (input) => {
  const isInvalid = !input.checked;
  const isValid = input.checked;
  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(input, "[data-validate-checked-message]");
  }

  return isValid;
};

// ❗Validate is email
const isEmail = (value, input) => {
  const isInvalid = !validator.isEmail(value);
  const isValid = !isInvalid;

  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(input, "[data-validate-email-message]");
  } else {
    showSuccessMessage(input);
  }
  return isValid;
};

// ❗ Validate is min length
const isMinLength = (value, input) => {
  const inputData = input.dataset;
  const isInvalid = !validator.isLength(value.trim(), {
    min: parseInt(inputData.validateMinLength),
    max: undefined,
  });
  const isValid = !isInvalid;

  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(input, "[data-validate-min-length-message]");
  } else {
    showSuccessMessage(input);
  }

  return isValid;
};

// ❗ Validate is max length
const isMaxLength = (value, input) => {
  const inputData = input.dataset;
  const isInvalid = !validator.isLength(value.trim(), {
    min: undefined,
    max: parseInt(inputData.validateMaxLength),
  });
  const isValid = !isInvalid;

  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(input, "[data-validate-max-length-message]");
  } else {
    showSuccessMessage(input);
  }

  return isValid;
};

// ❗ Validate is min number
const isMinNumber = (value, input) => {
  const inputData = input.dataset;
  const numValue = parseFloat(value);
  const minNumber = parseFloat(inputData.validateMinNumber);

  const isInvalid = isNaN(numValue) || numValue < minNumber;
  const isValid = !isInvalid;

  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(input, "[data-validate-min-number-message]");
  } else {
    showSuccessMessage(input);
  }

  return isValid;
};

// ❗ Validate is max number
const isMaxNumber = (value, input) => {
  const inputData = input.dataset;
  const numValue = parseFloat(value);
  const maxNumber = parseFloat(inputData.validateMaxNumber);

  const isInvalid = isNaN(numValue) || numValue > maxNumber;
  const isValid = !isInvalid;

  if (isInvalid) {
    input.setCustomValidity(" ");
    showErrorMessage(input, "[data-validate-max-number-message]");
  } else {
    showSuccessMessage(input);
  }

  return isValid;
};

let errors = [];

// Add error
const addError = (isInavalid, input) => {
  if (isInavalid && !errors.includes(input)) {
    errors.push(input);
  }
};

const removeError = (input) => {
  errors = errors.filter((el) => el !== input);
};

// 📐 Validator for inputs (run all rules)
const inputValidator = (input, inputTypeValid) => {
  const value = input.value;

  input.setCustomValidity("");
  clearErrorMessage(input);

  // Email format
  if (inputTypeValid.validateEmail !== undefined && value.length !== 0) {
    const isValid = isEmail(value, input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  } else {
    removeError(input);
  }

  // Min lenght chart
  if (inputTypeValid.validateMinLength !== undefined && value.length !== 0) {
    const isValid = isMinLength(value, input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  } else {
    removeError(input);
  }

  // Max lenght chart
  if (inputTypeValid.validateMaxLength !== undefined && value.length !== 0) {
    const isValid = isMaxLength(value, input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  } else {
    removeError(input);
  }

  // Min number
  if (inputTypeValid.validateMinNumber !== undefined && value.length !== 0) {
    const isValid = isMinNumber(value, input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  } else {
    removeError(input);
  }

  // Max number
  if (inputTypeValid.validateMaxNumber !== undefined && value.length !== 0) {
    const isValid = isMaxNumber(value, input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  } else {
    removeError(input);
  }

  // Phone (select country code)
  if (
    (inputTypeValid.validatePhoneFormat !== undefined) &
    (value.length !== 0)
  ) {
    const isValid = isPhoneWithCountryCode(value, input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  } else {
    removeError(input);
  }

  // Phone
  if (inputTypeValid.validatePhone !== undefined && value.length !== 0) {
    const isValid = isPhone(value, input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  } else {
    removeError(input);
  }

  // Required
  if (inputTypeValid.validateRequired !== undefined) {
    const isValid = isRequired(value, input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  }

  // Checked (radio group)
  if (inputTypeValid.validateRadioChecked !== undefined) {
    const isValid = isCheckedGroup(input);

    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  }

  // Checked
  if (inputTypeValid.validateChecked !== undefined) {
    const isValid = isChecked(input);
    if (isValid) {
      removeError(input);
    } else {
      addError(!isValid, input);
    }
  }

  return { errors: errors };
};

// 🖱️ Event listener
// Single input validation
if (validateInputs.length !== 0) {
  validateInputs.forEach((input) => {
    const inputTypeValid = input.dataset;

    input.addEventListener("input", (e) => {
      const input = e.target;
      inputValidator(input, inputTypeValid);
    });

    // input.addEventListener("paste", (e) => {
    //   e.preventDefault();
    //   const pastedData = (e.clipboardData || window.clipboardData).getData(
    //     "text",
    //   );

    //   input.value = pastedData;

    //   const inputEvent = new Event("input", {
    //     bubbles: true,
    //     cancelable: true,
    //   });
    //   input.dispatchEvent(inputEvent);
    // });
  });
}

// Test
// document.querySelector("[data-submit]").addEventListener("click", () => {
//   formIsValid(document.querySelector("[data-form]"));
// });

export { isPhoneWithCountryCode, inputValidator };

// Form validation
// if (formValidate && validateInputs.length !== 0) {
//   formValidate.addEventListener("submit", (e) => {
//     e.preventDefault();

//     const formButton = formValidate.querySelector(".js-button-loader");

//     if (formButton && formIsValid(formValidate)) {
//       // buttonLoaderShow(formButton);
//     }

//     // if (formIsValid(formValidate)) {
//     //   const response = formSend(formValidate);

//     //   response
//     //     .then((res) => {
//     //       showResponseMessage(formValidate, res);
//     //       if (res.status === 200) {
//     //         formReset(formValidate);
//     //       }

//     //       // buttonLoaderHide(formButton);
//     //     })
//     //     .catch((err) => {
//     //       // buttonLoaderHide(formButton);
//     //     });
//     // }
//   });
// }
